export default "__VITE_ASSET__3_78jJlEnRzZwIKkZ_ZS6w__"